import React, { useEffect, useState } from "react";
import styles from "./FiltersComponents.module.css";
import fetchSpreadsheetData from "../../Services/companiesData";
import CustomDropdown from "../CustomDropdown/CustomDropdown";

function FiltersComponent() {
  const [companyNames, setCompanyNames] = useState([]);
  const [companyCountries, setCompanyCountries] = useState([]);
  const [sectors, setSectors] = useState([]);
  useEffect(() => {
    async function getData() {
      try {
        const { companyNames, companyCountries, sectors } =
          await fetchSpreadsheetData();

        setCompanyNames(companyNames);
        setCompanyCountries(companyCountries);
        setSectors(sectors);
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors
      }
    }

    getData();
  }, []);

  return (
    <div className={styles.sectionContainer}>
      <CustomDropdown
        filterType="companyCountries"
        options={companyCountries}
        placeholder={"Country"}
      />
      <CustomDropdown
        filterType="companyNames"
        options={companyNames}
        placeholder={"Company"}
      />
      <CustomDropdown
        filterType="sectors"
        options={sectors}
        placeholder={"Sector"}
      />
    </div>
  );
}

export default FiltersComponent;
